import { useEffect } from "react";
import { C } from "../../../lib/tokens.js";
import { useViewport } from "../../../lib/useViewport.js";
import { PageSpinner } from "../../../components/ui/Misc.jsx";
import { RequestDetail } from "./RequestDetailPage.jsx";

// Jira-style "peek" - the Kanban card's background opens this instead of
// navigating away from the board; the card's own docNumber/summary text is a
// separate link that still navigates to the full /requests/:id page.
export function RequestPeekPanel({ id, detailCache, fetchDetail, role, me, updateRequest, postTransition, addComment, tweaks, onClose }) {
  const { isMobile } = useViewport();

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  useEffect(() => {
    if (id) fetchDetail(id);
  }, [id, fetchDetail]);

  const request = detailCache?.[String(id)];

  return (
    <>
      <div
        onClick={onClose}
        style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.35)", zIndex: 200 }}
      />
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "fixed", top: 0, right: 0, bottom: 0, zIndex: 201,
          width: isMobile ? "100vw" : 900, maxWidth: "100vw",
          background: C.platinum, boxShadow: "-8px 0 32px rgba(0,0,0,0.18)",
          display: "flex", flexDirection: "column",
        }}
      >
        {!request ? (
          <PageSpinner label="Loading request…" />
        ) : (
          <RequestDetail
            key={request.id}
            request={request}
            role={role}
            me={me}
            onBack={onClose}
            backLabel="Close"
            backIcon="close"
            onUpdate={updateRequest}
            onPostTransition={postTransition}
            onAddComment={addComment}
            onRefresh={fetchDetail}
            showPriority={tweaks.showPriority}
          />
        )}
      </div>
    </>
  );
}
